import { CustomElement } from '@aurelia/runtime-html';
import "./app.scss";
export const name = "app";
export const template = "<div id=\"main-page-host\" class=\"page-host ${scrollBarClass}\" data-event=\"load\">\n    <navbar pages.bind=\"pages\" user.bind=\"user\" currency-options.bind=\"currencyOptions\" if.bind=\"showHeaderAndFooter\"></navbar>\n    <div class=\"body-container\">\n        <au-viewport></au-viewport>\n    </div>\n    <footer if.bind=\"showHeaderAndFooter\"></footer>\n</div>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
